import "core-js/modules/es.array.push.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import moment from 'moment';
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { DoctorService } from '@/services/doctor.service';
import { OOO_TABLE_HEADERS_LIST, OOO_COLUMN_OPTIONS_LIST, OOO_STATUS_OPTIONS_LIST, OOO_STATE_OPTIONS_LIST } from '@/constants/ooo';
import CoreTooltip from '@corefront/components-v2/Core/CoreTooltip.vue';
export default {
  components: {
    CoreTooltip
  },
  data() {
    return {
      headers: OOO_TABLE_HEADERS_LIST,
      items: [],
      total: 0,
      fetching: false,
      tabCounts: {
        pending: '—',
        active: '—',
        cancelled: '—',
        all: '—'
      },
      currentPage: parseInt(this.$route.query.page) || 1,
      search: this.$route.query.search || '',
      debouncedSearch: this.$route.query.search || '',
      searchDebouncer: null,
      filters: [],
      pendingFilters: [],
      fetchVersion: 0,
      columnOptions: OOO_COLUMN_OPTIONS_LIST,
      statusOptions: OOO_STATUS_OPTIONS_LIST,
      stateOptions: OOO_STATE_OPTIONS_LIST
    };
  },
  computed: {
    ...mapGetters('auth', ['isManager']),
    tab() {
      const valid = ['all', 'pending', 'active', 'cancelled'];
      return valid.includes(this.$route.query.tab) ? this.$route.query.tab : 'all';
    },
    tableHeightStyle() {
      const offset = 350 + (this.filters.length > 0 ? 44 : 0);
      const h = `calc(100vh - ${offset}px)`;
      return {
        maxHeight: `${h} !important`,
        height: `${h} !important`
      };
    }
  },
  watch: {
    search() {
      this.searchDebouncer();
    },
    async debouncedSearch() {
      this.currentPage = 1;
      await this.fetchData();
    },
    async tab() {
      this.currentPage = 1;
      await this.fetchData();
    }
  },
  async mounted() {
    this.searchDebouncer = _.debounce(() => {
      this.debouncedSearch = this.search;
      this.$router.replace({
        query: {
          ...this.$route.query,
          search: this.search.trim() || undefined,
          page: undefined
        }
      }).catch(() => {});
    }, 500);
    this.fetchTabCounts();
    await this.fetchData();
  },
  beforeDestroy() {
    if (this.searchDebouncer) {
      this.searchDebouncer.cancel();
    }
  },
  methods: {
    async fetchTabCounts() {
      const tabs = ['pending', 'active', 'cancelled', 'all'].filter(tab => tab !== this.tab);
      try {
        const results = await Promise.all(tabs.map(tab => DoctorService.getOooRequests({
          tab,
          limit: 1,
          offset: 0
        })));
        tabs.forEach((tab, index) => {
          this.tabCounts[tab] = results[index].data.pagination.total;
        });
      } catch (e) {
        console.error('Failed to fetch tab counts', e);
      }
    },
    async fetchData() {
      this.fetchVersion += 1;
      const version = this.fetchVersion;
      this.fetching = true;
      try {
        const offset = (this.currentPage - 1) * 25;
        const payload = {
          tab: this.tab,
          limit: 25,
          offset,
          sortBy: 'startdatestamp',
          sortDir: 'desc'
        };
        if (this.debouncedSearch.trim()) {
          payload.search = this.debouncedSearch.trim();
        }
        if (this.filters.length) {
          const activeFilter = this.filters.find(f => f.column === 'status' && f.value === 'ACTIVE');
          if (activeFilter) {
            payload.tab = 'active';
            payload.filters = this.filters.filter(f => f !== activeFilter);
          } else {
            payload.filters = this.filters;
          }
        }
        const {
          data
        } = await DoctorService.getOooRequests(payload);
        if (version !== this.fetchVersion) {
          return;
        }
        this.tabCounts[this.tab] = data.pagination.total;
        this.items = data.data;
        this.total = data.pagination.total;
      } catch (e) {
        console.error('Failed to fetch OOO requests', e);
      } finally {
        if (version === this.fetchVersion) {
          this.fetching = false;
        }
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    async refresh() {
      await this.fetchData();
      this.fetchTabCounts();
    },
    setOooTab(newTab) {
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: newTab,
          page: undefined
        }
      }).catch(() => {});
    },
    handlePaginationClick(_event, pageNumber) {
      this.currentPage = pageNumber;
      this.$router.replace({
        query: {
          ...this.$route.query,
          page: pageNumber > 1 ? pageNumber : undefined
        }
      }).catch(() => {});
      this.fetchData();
    },
    canEdit(row) {
      if (row.requeststatus === 'PENDING') {
        return true;
      }
      if (row.requeststatus === 'APPROVED' && Number(row.startdatestamp) > moment().unix()) {
        return true;
      }
      return false;
    },
    showViewButton(row) {
      if (row.requeststatus !== 'APPROVED') {
        return false;
      }
      if (Number(row.startdatestamp) > moment().unix()) {
        return false;
      }
      if (row.reassignmentstatus === 'TRANSFERRED') {
        return true;
      }
      if (row.reassignmentstatus === 'PROCESSING' && row.enddatestamp && Number(row.enddatestamp) >= moment().unix()) {
        return true;
      }
      return false;
    },
    showCancel(row) {
      if (row.reassignmentstatus === 'RETURNED') {
        return false;
      }
      if (row.reassignmentstatus === 'PROCESSING' && row.enddatestamp && Number(row.enddatestamp) < moment().unix()) {
        return false;
      }
      return row.requeststatus === 'APPROVED';
    },
    formatStatus(row) {
      const {
        requeststatus,
        reassignmentstatus,
        startdatestamp
      } = row;
      if (!requeststatus) {
        return '—';
      }
      if (reassignmentstatus === 'DENIED') {
        return 'Denied';
      }
      if (requeststatus === 'APPROVED' && reassignmentstatus === 'RETURNED') {
        return 'Completed';
      }
      if (requeststatus === 'APPROVED' && ['APPROVED', 'PROCESSING', 'TRANSFERRED'].includes(reassignmentstatus) && Number(startdatestamp) <= moment().unix()) {
        return 'Active';
      }
      return requeststatus.charAt(0).toUpperCase() + requeststatus.slice(1).toLowerCase();
    },
    getDate(date) {
      if (!date) {
        return 'Indefinite';
      }
      return moment(date * 1000).format('MM/DD/YYYY LT');
    },
    getFirstStates(states) {
      return states.slice(0, 5).map(s => s.state).join(', ');
    },
    getRemainingStates(states) {
      return states.slice(5).map(s => s.state).join(', ');
    },
    getSortedDoctors(row) {
      if (!row.doctorlistdetails) {
        return [];
      }
      const oooStates = new Set((row.coveredstate || []).map(s => s.state));
      return [...row.doctorlistdetails].sort((a, b) => {
        const aCount = (a.coveredstate || []).filter(s => oooStates.has(s.state)).length;
        const bCount = (b.coveredstate || []).filter(s => oooStates.has(s.state)).length;
        if (bCount !== aCount) {
          return bCount - aCount;
        }
        const aName = `${a.firstname} ${a.lastname}`.toLowerCase();
        const bName = `${b.firstname} ${b.lastname}`.toLowerCase();
        return aName < bName ? -1 : aName > bName ? 1 : 0;
      });
    },
    clearSearch() {
      this.search = '';
      this.$refs.searchInput.focus();
    },
    onFilterPanelShow() {
      this.pendingFilters = this.filters.map(filter => {
        if ((filter.column === 'startDate' || filter.column === 'endDate') && filter.value) {
          return {
            ...filter,
            value: moment.unix(filter.value).format('YYYY-MM-DD')
          };
        }
        return {
          ...filter
        };
      });
      if (this.pendingFilters.length === 0) {
        this.pendingFilters.push(this.newCondition());
      }
    },
    newCondition() {
      return {
        column: 'status',
        operator: 'eq',
        value: ''
      };
    },
    addCondition() {
      this.pendingFilters.push(this.newCondition());
    },
    removeCondition(index) {
      this.pendingFilters.splice(index, 1);
    },
    onColumnChange(index) {
      const col = this.pendingFilters[index].column;
      const [first] = this.getOperators(col);
      this.pendingFilters[index].operator = first.value;
      this.pendingFilters[index].value = '';
    },
    getOperators(column) {
      switch (column) {
        case 'status':
          return [{
            value: 'eq',
            text: 'is'
          }, {
            value: 'neq',
            text: 'is not'
          }];
        case 'state':
          return [{
            value: 'eq',
            text: 'is'
          }, {
            value: 'neq',
            text: 'is not'
          }];
        case 'startDate':
        case 'endDate':
          return [{
            value: 'gte',
            text: 'is after'
          }, {
            value: 'lte',
            text: 'is before'
          }];
        default:
          return [{
            value: 'contains',
            text: 'contains'
          }];
      }
    },
    applyFilters() {
      this.filters = this.pendingFilters.filter(cond => cond.value && String(cond.value).trim()).map(cond => {
        if (cond.column === 'startDate' || cond.column === 'endDate') {
          return {
            column: cond.column,
            operator: cond.operator,
            value: moment(cond.value, 'YYYY-MM-DD').unix()
          };
        }
        return {
          column: cond.column,
          operator: cond.operator,
          value: cond.value
        };
      });
      this.$refs.filterDropdown.hide();
      this.currentPage = 1;
      this.$router.replace({
        query: {
          ...this.$route.query,
          page: undefined
        }
      }).catch(() => {});
      this.fetchData();
    },
    cancelFilter() {
      this.$refs.filterDropdown.hide();
    },
    clearAllFilters() {
      this.filters = [];
      this.currentPage = 1;
      this.$router.replace({
        query: {
          ...this.$route.query,
          page: undefined
        }
      }).catch(() => {});
      this.fetchData();
    },
    removeFilter(index) {
      this.filters.splice(index, 1);
      this.currentPage = 1;
      this.$router.replace({
        query: {
          ...this.$route.query,
          page: undefined
        }
      }).catch(() => {});
      this.fetchData();
    },
    formatFilterChip(filter) {
      var _this$getOperators$fi;
      const colLabel = (this.columnOptions.find(option => option.value === filter.column) || {}).text || filter.column;
      const opLabel = ((_this$getOperators$fi = this.getOperators(filter.column).find(option => option.value === filter.operator)) === null || _this$getOperators$fi === void 0 ? void 0 : _this$getOperators$fi.text) || filter.operator;
      let val;
      if (filter.column === 'status') {
        val = (this.statusOptions.find(option => option.value === filter.value) || {}).text || filter.value;
      } else if (filter.column === 'state') {
        val = (this.stateOptions.find(option => option.value === filter.value) || {}).text || filter.value;
      } else if (filter.column === 'startDate' || filter.column === 'endDate') {
        val = moment.unix(filter.value).format('MMM D, YYYY');
      } else {
        val = filter.value;
      }
      return `${colLabel} ${opLabel}: ${val}`;
    }
  }
};